class SelectTypeController {

    constructor($window, configService) {
        this.$window = $window;
        this.configService = configService;
    }

    $onInit () {
        this.property = this.configService.get('property');

        this.getExistingType();

        if (!this.eventType
            || this.eventType === 'category') {
            if (this.property.hasTreatments) {
                this.eventType = 'treatment';
                return;
            }

            this.eventType = 'day';
        }
    }

    displaySelect () {
        return !!(this.property.hasTreatments && this.property.hasSpaDays);
    }

    getExistingType () {
        const selectEl = this.$window.document.getElementsByClassName('select-type')[0];
        if (selectEl) {
            this.eventType = selectEl.value;
        }
    }
}

SelectTypeController.$inject = ['$window', 'configService'];

export default SelectTypeController;



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/page/controllers/selectType.controller.js